import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 via-blue-600 to-teal-500">
      <div className="text-center px-4">
        {/* Animated 404 with BizHub Branding */}
        <div className="relative mb-8">
          <div 
            className="w-full max-w-2xl mx-auto h-96 bg-center bg-no-repeat flex items-center justify-center"
            style={{
              backgroundImage: 'url(/bg.gif)',
              backgroundSize: 'contain'
            }}
          >
            <h1 className="text-9xl font-bold text-white drop-shadow-2xl">
              404
            </h1>
          </div>
        </div>

        {/* Error Message */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 max-w-md mx-auto border border-white/20 shadow-2xl">
          <h2 className="text-3xl font-bold text-white mb-4">
            Oops! Page Not Found
          </h2>
          <p className="text-white/90 text-lg mb-6">
            The page you're looking for doesn't exist or has been moved.
          </p>

          {/* BizHub Branding */}
          <div className="mb-6">
            <p className="text-white/80 text-sm">
              <span className="font-bold text-yellow-300">BizHub</span> - Let's Talk Strategy
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={handleGoHome}
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Go to Dashboard
            </button>

            {/* Auto-redirect countdown */}
            <p className="text-white/70 text-sm">
              Auto-redirecting in {countdown} seconds...
            </p>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 flex justify-center gap-6 text-white/80 text-sm">
          <button 
            onClick={() => navigate('/dashboard')} 
            className="hover:text-white transition-colors"
          >
            Dashboard
          </button>
          <button 
            onClick={() => navigate('/asksara')} 
            className="hover:text-white transition-colors"
          >
            Ask Sara
          </button>
          <button 
            onClick={() => navigate('/profile')} 
            className="hover:text-white transition-colors"
          >
            Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
